// extracted by mini-css-extract-plugin
module.exports = {"atom-submit-search-button-container":"styles_atom-submit-search-button-container__02W_b","icon":"styles_icon__TpMWO"};